export default "__VITE_ASSET__CJp07t4q__"